import Autocomplete from "react-autocomplete";
import { withStyles, ListItem } from "@material-ui/core";
import { StyledTextField as TextField } from "./TextField";
import WithRowLabel from "./WithRowLabel";

const styles = (theme) => ({
  highlighted: {
    backgroundColor: theme.HeaderSelectedText,
    color: theme.white,
  },
  listItem: {
    cursor: "pointer",
    fontSize: 12,
  },
  wrapper: {
    width: "100%",
    position: "relative",
  },
  menuContainer: {
    position: "absolute",
    zIndex: 2,
    maxHeight: 400,
    width: "100%",
    overflow: "auto",
    backgroundColor: theme.ModalBGColor,
    color: theme.TextColor,
  },
  menuBorder: {
    border: `1px solid ${theme.AnchorBGColor}`,
  },
  textField1: {
    margin: 1,
    width: "100%",
  },
});
const AutoComplete = ({
  classes,
  handleChange,
  value,
  handleSelect,
  placeholder,
  disabled,
  inputProps,
  onKeyPress,
  OptionsRenderer,
  error,
  showLoader,
  loadingMessage,
  forwardRef,
  noOptionsMsg,
  id,
  ...other
}) => {
  const onChange = (event) => {
    const inputValue = event.target.value;
    if (inputProps?.pattern) {
      checkPatternValidation(inputValue)
        ? handleChange(inputValue)
        : event.preventDefault();
    } else {
      handleChange(inputValue);
    }
  };

  const checkPatternValidation = (inputValue) => {
    const format = inputProps.pattern;
    return format.test(inputValue) || inputValue === "";
  };
  return (
    <Autocomplete
      wrapperProps={{ className: classes.wrapper }}
      getItemValue={(item) => JSON.stringify(item)}
      renderItem={(item, highlighted) =>
        OptionsRenderer ? (
          <span
            key={item?.id}
            className={`${classes.listItem} ${
              highlighted ? classes.highlighted : ""
            }`}
          >
            <OptionsRenderer props={{ data: { ...item }, isFocused: highlighted }} />
          </span>
        ) : (
          <ListItem
            key={item?.id}
            className={`${classes.listItem} ${
              highlighted ? classes.highlighted : ""
            }`}
          >
            {item.label}
          </ListItem>
        )
      }
      className={classes.input}
      inputProps={{
        ...inputProps,
        placeholder: placeholder,
        className: classes.textField1,
        id,
      }}
      renderMenu={(items) => {
        return items.length ? (
          <div
            className={`${classes.menuContainer} ${
              items.length && classes.menuBorder
            } customScroll`}
            children={items}
          ></div>
        ) : (
          <div className={`${classes.menuContainer} ${classes.menuBorder}`}>
            <ListItem className={classes.listItem}>
              {showLoader ? loadingMessage : noOptionsMsg ?? "No Options"}
            </ListItem>
          </div>
        );
      }}
      renderInput={(props) => {
        const { ref, pattern, maxLength, ...rest } = props;
        return (
          <TextField
            value={value}
            {...rest}
            handleChange={handleChange}
            inputProps={inputProps}
            disabled={disabled}
            inputRef={ref}
            onKeyPress={onKeyPress}
            error={error}
          />
        );
      }}
      value={value}
      onChange={onChange}
      onSelect={(inputValue) => handleSelect(inputValue)}
      {...other}
      ref={forwardRef}
    />
  );
};

const AutoCompleteInput = withStyles(styles)(AutoComplete);
const AutoCompleteInputWithLabel = WithRowLabel(AutoCompleteInput);
export { AutoCompleteInput, AutoCompleteInputWithLabel };